import {SET_SORT} from "./types";

export const setSort = (field, order) => {
    return {
        type: SET_SORT,
        field, order
    }
}